import { cx } from '@vizit/theme';
import { Text, type TextProps, TextSize } from '../text';

/**
 * The FieldHelper component is used to display a helper text for a field.
 *
 * @param props - The props for the FieldHelper component.
 * @example
 * <FieldHelper>
 *   Helper Text
 * </FieldHelper>
 */
function FieldHelper(props: TextProps) {
  const { className, ...other } = props;

  return <Text {...other} size={TextSize.Sm} className={cx('text-tertiary', className)} slot="description" />;
}

export { FieldHelper };
